import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";


const  InLandTransportDetail=({saveData,updateData,renderForm,repeatableValidationMethods:{updateErrors,validateError}})=>{
   const inlandTransportMode=useSelector(state=>state.transportReducer.inlandTransportMode)
   const dispatch=useDispatch()
    const onSelect=useCallback((e, {value,name})=>{
      dispatch(updateData({[name]:value?.trim()}))
      saveData({[name]:value || " "})
      if (!validateError || !updateErrors) return null
      const errors = dispatch(
        validateError('transportReducer', 'departureTransportMeansList', 'DEPARTURE_TRANSPORT_MEANS')
      )
  
      updateErrors(errors, ['DEPARTURE_TRANSPORT_MEANS'])
    
    
    },[updateData,,validateError,updateErrors,])
  
  return(
    renderForm && renderForm({onSelect,inlandTransportMode})
  )
}


export default InLandTransportDetail